import { render, staticRenderFns } from "./pie-echart-component.vue?vue&type=template&id=12357cfa"
import script from "./pie-echart-component.vue?vue&type=script&lang=js"
export * from "./pie-echart-component.vue?vue&type=script&lang=js"
import style0 from "./pie-echart-component.vue?vue&type=style&index=0&id=12357cfa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports